const membershipId = (player) => player?.membershipId;

export const lineupPlayerSectionRecord = (player, sectionKey) => {
  const record = player?.sectionRecords?.find(
    (value) => String(value.sectionKey) === String(sectionKey),
  );
  if (!record?.played) return { wins: 0, losses: 0, percentageLabel: "New" };
  const percentage = Number(record.winPercentage);
  const percentageLabel = Number.isFinite(percentage)
    ? `${percentage.toFixed(percentage % 1 ? 1 : 0)}%`
    : `${Math.round((Number(record.wins) * 100) / Number(record.played))}%`;
  return { wins: record.wins, losses: record.losses, percentageLabel };
};

export const lineupPlayerOptionLabel = (player, sectionKey) => {
  const name = `${player?.firstName || ""} ${player?.lastName || ""}`.trim();
  const record = lineupPlayerSectionRecord(player, sectionKey);
  return `${name} — ${record.wins}–${record.losses} · ${record.percentageLabel}`;
};

export const availableLineupPlayers = (
  roster,
  games,
  gameIndex,
  slotIndex,
  sectionKeys,
) => {
  const currentId = games[gameIndex]?.playerIds?.[slotIndex] || "";
  const targetSection = sectionKeys[gameIndex];
  const selectedElsewhere = new Set();
  games.forEach((game, index) => {
    if (sectionKeys[index] !== targetSection) return;
    (game.playerIds || []).forEach((id, playerIndex) => {
      if (index !== gameIndex || playerIndex !== slotIndex) selectedElsewhere.add(id);
    });
  });
  return roster.filter(
    (player) => membershipId(player) === currentId || !selectedElsewhere.has(membershipId(player)),
  );
};

export const assignLineupPlayer = (
  games,
  gameIndex,
  slotIndex,
  selectedId,
  sectionKeys,
) => games.map((game, index) => {
  let playerIds = [...(game.playerIds || [])];
  if (selectedId && sectionKeys[index] === sectionKeys[gameIndex] && index !== gameIndex)
    playerIds = playerIds.filter((id) => id !== selectedId);
  if (index === gameIndex) {
    while (playerIds.length <= slotIndex) playerIds.push("");
    playerIds[slotIndex] = selectedId;
    playerIds = playerIds.filter(Boolean);
  }
  return { ...game, playerIds };
});
